export default __webpack_public_path__ + "static/media/listSearchIcon.49ef0bd1.svg";